export const KEY_GRAPHQL_SETTINGS = "kahun.graphql-client-settings";
